
















































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import HacoBase from "../HacoBase";

@Component
export default class OtherComp extends HacoBase {
  editData: any = {};
  $debugServer!: string;
  $currentPage!: string;
  @Prop({ type: String, required: false }) private dialogText!: string;
  roundTo = [10, 100, 1000];

  mounted(): void {
    const url = this.$debugServer + "/api/v1_inner/other/";
    const params: object = this.setAxiosParams(url, "get");
    axios(params)
      .then((response: any): void => {
        this.editData = response.data;
        this.editData.other.id = 0;
      })
      .catch((error: any): void => {
        console.log("[mount error]", error.response);
        this.toLoginPage(error);
      });
  }

  checkInputKeys(e: KeyboardEvent): void {
    if (e.ctrlKey === true && e.key === "Enter") {
      this.onSubmit();
    }
  }

  afterSaving(): void {
    void 0;
  }

  onSubmit(back = false): void {
    const mes = this.$t("message.editCommon.saveConfirmation");
    const confirmation: boolean = confirm(mes as string);
    if (confirmation === false) {
      return;
    }
    const formElement: HTMLFormElement = document.getElementById(
      "editForm"
    ) as HTMLFormElement;
    if (formElement !== null && formElement.reportValidity() === false) {
      return;
    }

    const editData: any = this.editData;
    interface CategoryObj {
      category: string;
      backTo: string;
      dataName: string;
    }
    const categoryObj: CategoryObj = {
      category: "other",
      backTo: "Other",
      dataName: "other"
    };
    const id: number = parseInt(editData.other.id, 10);
    this.sendEditData(id, editData, categoryObj, back, this.afterSaving);
  }
}
